// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wBH6-","questions":"styles_questions__3X3Vj","footer":"styles_footer__2wJnW"};